import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, Typography, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import Copy from 'react-feather/dist/icons/copy';
import NREllipsisTooltipStyles from './NREllipsisTooltip.styles';
const useStyles = makeStyles(NREllipsisTooltipStyles);

const NREllipsisTooltip = ({ text, content, maxWidth = 200, showCopyOnEllipsis = false, copyValue }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowed(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [text, content, maxWidth]);

  const handleCopy = event => {
    event.stopPropagation();
    navigator.clipboard.writeText(copyValue ?? text);
    enqueueSnackbar('copied!', { variant: 'success', preventDuplicate: true, autoHideDuration: 1000 });
  };

  return (
    <>
      <Tooltip title={text}>
        <Typography ref={textRef} className={classes.ellipsisText} style={{ maxWidth }} component="span">
          {content ? content : text}
        </Typography>
      </Tooltip>
      {showCopyOnEllipsis && isOverflowed && (
        <Tooltip title="Copy to clipboard">
          <IconButton
            sx={{
              flexShrink: 0,
              padding: 0,
              marginLeft: theme.spacing(0.5),
              color: theme.palette.text.icon
            }}
            onClick={handleCopy}
            aria-label="Copy to clipboard"
            size="small"
          >
            <Copy size={14} />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};

export default NREllipsisTooltip;
